import { Box, Modal } from '@mui/material';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const MainModal = styled(Modal)(({ theme }) => ({
  height: '95vh',
  maxHeight: '800px',
  maxWidth: '425px',
  margin: 'auto',
  overflowY: 'scroll',
  backgroundColor: '#292739',
  borderRadius: '50px',
  boxShadow: theme.shadows[10],
  paddingBottom: '30px',
  [theme.breakpoints.down('sm')]: {
    height: '90%',
    width: '90%',
    backgroundColor: '#292739',
    borderRadius: '50px',
    boxShadow: theme.shadows[10],
    paddingBottom: '30px',
  },
}));

export const Body = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start',
  paddingBottom: '50px',
  width: '100%',
  height: '100%',
}));

export const Image = styled('img')(({ theme }) => ({
  width: '100%',
  height: '229px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    height: '200px',
  },
}));

export const ContentGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  paddingLeft: '27px',
  paddingRight: '27px',
  [theme.breakpoints.down('sm')]: {
    paddingTop: '0px',
  },
}));

export const TitleText = styled(Typography)(({ theme }) => ({
  color: '#ffffff',
  fontSize: '25px',
  fontWeight: 'bold',
  paddingBottom: '26px',
  marginTop: '20px',
}));
export const ParaText = styled(TitleText)(() => ({
  paddingBottom: '20px',
  fontSize: '16px',
  color: '#c1c1c1',
  fontWeight: 'normal',
}));

export const WalletCont = styled(Box)(() => ({
  displat: 'flex',
  justifyContent: 'center',
  margin: '20px auto',
  maxWidth: '200px',
  width: '100%',
}));

export const MetaMaskCard = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '20px 15px',
  borderRadius: '10px',
  backgroundImage: 'linear-gradient(90deg, #ff5e00, #ffff2e)',
  '& span': {
    color: '#fff',
    fontWeight: 'bolder',
  },
  '&:hover': {
    cursor: 'pointer',
  },
  '& img': {
    marginLeft: '10px',
  },
}));
